var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.396,
    height: 7.731,
    viewBox: "0 0 17.396 7.731",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.396 7.731) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.295,3.6,13.429.081a.323.323,0,0,0-.352-.05.292.292,0,0,0-.191.292V2.578H.322A.31.31,0,0,0,0,2.9V4.833a.31.31,0,0,0,.322.322H12.886V7.409a.3.3,0,0,0,.191.292.314.314,0,0,0,.352-.06l3.866-3.564a.329.329,0,0,0,.1-.241A.318.318,0,0,0,17.295,3.6Z",
    transform: "translate(0 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.69c5802d6beb66ec73ce9761527b570d.svg";
export { ForwardRef as ReactComponent };